import { clsx } from 'clsx';
import { Heading, Heart3, Paragraph } from '@hungryroot/ui-kit';
import { ADD_TO_COOKBOOK_TOAST_COPY } from './AddToCookbookToast';
import styles from './FavoriteToast.module.css';

interface FavoriteToastProps {
  isFavorited: boolean;
  /**
   * Replaces the generic add/remove sentence. Used for Exp 255 guests so the
   * toast says "Added to Cookbooks" / "Removed from Cookbooks".
   */
  copy?: string;
  onUndo: () => void;
  onDismiss: () => void;
}

export function FavoriteToast(props: FavoriteToastProps) {
  const { isFavorited, copy, onUndo, onDismiss } = props;

  return (
    <div className={styles.toast} onClick={onDismiss}>
      <Heart3
        className={clsx(styles.heart, {
          [styles.favorited]: isFavorited,
          [styles.removed]: !isFavorited,
        })}
      />
      <Paragraph variant="body" className={styles.copy}>
        {copy ??
          (isFavorited
            ? ADD_TO_COOKBOOK_TOAST_COPY.added
            : ADD_TO_COOKBOOK_TOAST_COPY.removed)}
      </Paragraph>
      <button
        type="button"
        className={styles.undo}
        onClick={(e) => {
          e.stopPropagation();
          onUndo();
          onDismiss();
        }}
      >
        <Heading variant="H7">Undo</Heading>
      </button>
    </div>
  );
}
